import { render } from "./CustomerBusiness.vue?vue&type=template&id=4022d852"
import script from "./CustomerBusiness.vue?vue&type=script&lang=js"
export * from "./CustomerBusiness.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__